import { Navigate } from "react-router-dom";

import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import ProvincesList from "views/content/ProvincesList.js";
import DealsList from "views/content/DealsList.js";
import AdsList from "views/content/AdsList.js";
import MobileCmsPage from "views/content/MobileCmsPage.js";


import DiscoverHome from "views/discover/Home.js";
import MapPage from "views/discover/MapPage.js";


import BusinessesList from "views/businesses/BusinessesList.js";


import ProfilePage from "views/profile/ProfilePage.js";
import MyBookings from "views/bookings/MyBookings.js";
import PaymentsPage from "views/payments/PaymentsPage.js";
import SavedPage from "views/saved/SavedPage.js";
import MyAlerts from "views/alerts/MyAlerts.js";


import PartnerHome from "views/partner/PartnerHome.js";
import PartnerBookings from "views/partner/PartnerBookings.js";
import PartnerMyBusinesses from "views/partner/PartnerMyBusinesses.js";


import AdminHome from "views/admin/AdminHome.js";
import AdminBusinesses from "views/admin/AdminBusinesses.js";
import AdminBookings from "views/admin/AdminBookings.js";
import AdminSubscriptions from "views/admin/AdminSubscriptions.js";
import AdminUsers from "views/admin/AdminUsers.js";
import AdminAlerts from "views/admin/AdminAlerts.js";
import AdminFavoritesOverview from "views/admin/AdminFavoritesOverview.js";
import AdminSupportRequests from "views/admin/AdminSupportRequests.js";
import AdminAppNotifications from "views/admin/AdminAppNotifications.js";
import AdminKadekon from "views/admin/AdminKadekon.js";
import AdminApplications from "views/admin/AdminApplications.js";
import { adminPaths } from "admin/paths";

var routes = [

  {
    path: "/index",
    name: "Kontrol Paneli",
    icon: "ni ni-tv-2 text-primary",
    component: <Navigate to={`/admin${adminPaths.dashboard}`} replace />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.discover,
    name: "Keşfet",
    icon: "ni ni-compass-04 text-info",
    component: <DiscoverHome />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.map,
    name: "Harita",
    icon: "ni ni-pin-3 text-orange",
    component: <MapPage />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: adminPaths.content.provinces.list,
    name: "Şehirler (Yönetim)",
    icon: "ni ni-map-big text-info",
    component: <ProvincesList />,
    layout: "/admin",
  },
  {
    path: adminPaths.content.deals.list,
    name: "Fırsatlar (Yönetim)",
    icon: "ni ni-tag text-primary",
    component: <DealsList />,
    layout: "/admin",
  },
  {
    path: adminPaths.content.ads.list,
    name: "Reklamlar (Yönetim)",
    icon: "ni ni-notification-70 text-warning",
    component: <AdsList />,
    layout: "/admin",
  },
  {
    path: adminPaths.content.mobileCms.list,
    name: "Mobil CMS",
    icon: "ni ni-mobile-button text-info",
    component: <MobileCmsPage />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: adminPaths.businesses,
    name: "İşletmeler",
    icon: "ni ni-shop text-success",
    component: <BusinessesList />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: adminPaths.profile,
    name: "Profilim",
    icon: "ni ni-single-02 text-yellow",
    component: <ProfilePage />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.bookings,
    name: "Rezervasyonlarım",
    icon: "ni ni-calendar-grid-61 text-primary",
    component: <MyBookings />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.payments,
    name: "Ödemelerim",
    icon: "ni ni-credit-card text-info",
    component: <PaymentsPage />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.saved,
    name: "Kaydedilenler",
    icon: "ni ni-favourite-28 text-danger",
    component: <SavedPage />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.alerts,
    name: "Bildirimler",
    icon: "ni ni-bell-55 text-warning",
    component: <MyAlerts />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: adminPaths.partner.home,
    name: "İş Ortağı Paneli",
    icon: "ni ni-building text-warning",
    component: <PartnerHome />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.partner.bookings,
    name: "Partner Rez.",
    icon: "ni ni-calendar-grid-61 text-warning",
    component: <PartnerBookings />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.partner.businesses,
    name: "Partner İşletmeler",
    icon: "ni ni-shop text-warning",
    component: <PartnerMyBusinesses />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: adminPaths.admin.home,
    name: "Yönetim",
    icon: "ni ni-settings-gear-65 text-dark",
    component: <AdminHome />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.applications,
    name: "Onay Bekleyenler",
    icon: "ni ni-check-bold text-warning",
    component: <AdminApplications />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.businesses,
    name: "İşletme Yönetimi",
    icon: "ni ni-shop text-dark",
    component: <AdminBusinesses />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.bookings,
    name: "Rezervasyon Yönetimi",
    icon: "ni ni-calendar-grid-61 text-dark",
    component: <AdminBookings />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.subscriptions,
    name: "Abonelik Yönetimi",
    icon: "ni ni-crown text-dark",
    component: <AdminSubscriptions />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.users,
    name: "Kullanıcı Yönetimi",
    icon: "ni ni-single-02 text-dark",
    component: <AdminUsers />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.alerts,
    name: "Uyarı Yönetimi",
    icon: "ni ni-bell-55 text-dark",
    component: <AdminAlerts />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.admin.notifications,
    name: "Uygulama bildirimleri",
    icon: "ni ni-send text-info",
    component: <AdminAppNotifications />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.kadekon,
    name: "KADEKON Club",
    icon: "ni ni-badge text-success",
    component: <AdminKadekon />,
    layout: "/admin",
  },
  {
    path: adminPaths.admin.favorites,
    name: "Favori İstatistikleri",
    icon: "ni ni-chart-bar-32 text-dark",
    component: <AdminFavoritesOverview />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: adminPaths.admin.supportRequests,
    name: "Destek Talepleri",
    icon: "ni ni-support-16 text-dark",
    component: <AdminSupportRequests />,
    layout: "/admin",
  },


  {
    path: "/icons",
    name: "İkonlar",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/maps",
    name: "Haritalar (Eski)",
    icon: "ni ni-pin-3 text-orange",
    component: <Maps />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/user-profile",
    name: "Kullanıcı Profili (Eski)",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/tables",
    name: "Tablolar",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    layout: "/admin",
    invisible: true,
  },


  {
    path: "/login",
    name: "Giriş",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/register",
    name: "Kayıt Ol",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
    invisible: true,
  },
];
export default routes;
